import React from "react";
import {
  Box,
  Typography,
  Skeleton,
  Stack,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { BarChart } from "@mui/x-charts";
import SoothCard from "components/base/SoothCard";
import { formatNumberWithCommas } from "../utils/util";
import { colorArray } from "../data/color.data";
import AccessibleIconButton from "components/base/AccessibleIconButton";

const PublisherSearchShareChart = ({ data, isLoading }) => {
  return (
    <SoothCard
      sx={{
        backgroundColor: (theme) => theme.palette.secondary.main,
        borderRadius: 2,
        p: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          mb: 2,
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Search Impressions
        </Typography>
        <AccessibleIconButton
          size="small"
          sx={{ p: 0.5 }}
          title="Distribution of search appearances across publishers, showing market share in search results."
          tooltipProps={{
            placement: "top",
          }}
        >
          <InfoOutlinedIcon fontSize="small" color="primary" />
        </AccessibleIconButton>
      </Box>
      {isLoading ? (
        <Stack
          direction="row"
          alignItems="flex-end"
          spacing={1}
          sx={{ height: 350 }}
        >
          {[...Array(10)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              height={`${Math.random() * 80 + 20}%`}
              sx={{ flex: 1 }}
            />
          ))}
        </Stack>
      ) : data?.length > 0 ? (
        <BarChart
          dataset={data}
          slotProps={{
            legend: { hidden: true },
          }}
          xAxis={[
            {
              scaleType: "band",
              dataKey: "publisherName",
              tickLabelStyle: {
                angle: -45,
                textAnchor: "end",
                fontSize: 12,
              },
              colorMap: {
                type: "ordinal",
                values: data.map((d) => d.publisherName),
                colors: colorArray,
                unknownColor: "#ccc",
              },
            },
          ]}
          series={[
            {
              dataKey: "searchSharePercentInt",
              label: "",
              valueFormatter: (value, context) =>
                `${value}% (${
                  context.dataIndex !== undefined
                    ? formatNumberWithCommas(
                        data[context.dataIndex]?.searchCount,
                        0
                      )
                    : ""
                } searches)`,
            },
          ]}
          height={350}
          margin={{ left: 60, right: 20, top: 40, bottom: 110 }}
          sx={{ width: "100%", height: "100%" }}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 350,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            No publisher share data available
          </Typography>
        </Box>
      )}
    </SoothCard>
  );
};

export default PublisherSearchShareChart;
